import Vue from 'vue';
import axios from 'axios';
import SelectAccount from '@/customcontrols/selectAccount.vue';

export default {
  name: 'SelectMasterCustomer',
  props: ['dataObj'],
  components: {
    SelectCustomer: require('@/employee/applications/appDetails/selectCustomer/selectCustomer.vue').default
  },
  data: function () {
    return {};
  },
  computed: {},
  watch: {},
  created() {
    this.init();
  },
  mounted() {
    this.$root.$emit('find_customer_updated');
  },
  methods: {
    init() {}
  }
};
